const GET_ALL_ROLE_DATA = 'GET_ALL_ROLE_DATA';
export { GET_ALL_ROLE_DATA}